import { render, staticRenderFns } from "./RateTen.vue?vue&type=template&id=6fda1f06&scoped=true&"
import script from "./RateTen.vue?vue&type=script&lang=js&"
export * from "./RateTen.vue?vue&type=script&lang=js&"
import style0 from "./RateTen.vue?vue&type=style&index=0&id=6fda1f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda1f06",
  null
  
)

export default component.exports